const transform = (questions) =>
  questions.map((question) => {
    const id = question.id;
    const title = question.title;
    const uri = question.uri;
    const numberOfAnswers = question.numberOfAnswers;

    return {
      id,
      title,
      uri,
      numberOfAnswers,
    };
  });

export default transform;
